export class OrderAttributes {
        coolTxtID: number = 0;
        sourceOrderNumber: string = '';
        ldc: string = '';
        sourceSystem: string = '';
        fieldStatus: string = '';
        isVoidable: boolean = false;
        isRescheduleEligible: boolean = false;
        marketerName: string = '';
        marketerPhoneNo: string = '';
        contactPhoneNo: string = '';
        urlCode: string = '';
}

export class AmendOrder {
    ldc: string = '';
    orderNumber: string = '';
    scheduleDate: string = '';
    scheduleWindow: string = '';
    fieldInstructions: string = '';
    premisesNumber: string = '';
    appointmentStart: string = '';
    appointmentEnd: string = '';
    personID: string = '';
}

//export class AppConfigurationData {
//    configurationKey: string = '';
//    configurationTitle: string = '';
//    configurationType: string = '';
//    configurationValue: string = '';
//    description: string = '';
//    ldc: string = '';
//}
